/* 🤖 this file was generated by svg-to-ts */
export const matIconAdUnits: {
  name: 'ad-units';
  data: string;
} = {
  name: 'ad-units',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 4V3h10v1H7zm0 14V6h10v12H7zm0 3v-1h10v1H7z"/><path d="M16 7H8v2h8V7z"/></svg>`
};
